<template>
  <main>
    <base-iframe
      class="mx-a"
      height="720"
      :src
      style="max-width: 70rem"
      :title="`${$t.studentDiscount} - Kolegio`"
      width="100%"
    />
  </main>
</template>

<script lang="ts" setup>
const { $feature } = useNuxtApp()
const locale = useLocale()
const iframeUrl = $feature.configStudentDiscount?.iframe_url
const vendorList = Array.isArray(iframeUrl) ? iframeUrl : iframeUrl?.[locale]
const src = vendorList?.find((entry: { vendor: string }) => entry.vendor === 'kolegio')?.url ?? ''
if (!src)
  throw createError({ statusCode: 404, fatal: true })
</script>
